export const TOKEN_REPLY = "TOKEN_KEY_REPLY";
export const PLANT_ID = "PLANT_ID";
export const TOKEN_IDENTIFICATION = "TOKEN_IDENTIFICATION";
export const COMPANY_ID = "COMPANY_ID";
export const USER_NAME = "USER_NAME";
export const USER_EMAIL = "USER_EMAIL";

export const checkIsProd = (): boolean => {
  return process.env.REACT_APP_ENV
    ? process.env.REACT_APP_ENV === "PROD"
    : false;
};

export const getUrlApi = (): any =>
  checkIsProd() ? process.env.REACT_APP_API_URL : process.env.REACT_APP_API_URL;

export const translateLanguagesList = (): any[] => {
  return [
    { name: "pt-BR", code: "pt" },
    { name: "pt-br", code: "pt" },
    { name: "en-us", code: "en" },
    { name: "en-US", code: "en" },
  ];
};
